module.exports = __webpack_public_path__ + "img/plan5.76518ac1.png";